import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    backgroundColor: 'common.lightBackgroundColor',
  },
  subContainer: {
    px: '30px',
    py: '18px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2,1fr)',
    gap: '10px',
  },

  title: {
    fontSize: '16px',
    mb: '16px',
  },
  boldText: {
    fontWeight: '600',
    color: 'common.grey850',
    fontSize: 14,
  },
  emptyContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    fontWeight: '600',
    fontSize: 15,
  },
  name: {
    fontSize: 16,
    fontWeight: '600',
    color: 'common.grey850',
  },
  buttonContainer: {
    gap: '15px',
    flex: 1,
    position: 'sticky',
    bottom: 0,
    width: '100%',
    paddingY: '16px',
    backgroundColor: 'common.lightBackgroundColor',
    justifyContent: 'flex-end',
    boxShadow: '0px -2px 4px 0px #0000000A',
  },
  closeButton: {
    mr: '40px',
    width: 202,
  },
  ratingContainer: {
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  ratingText: {
    ml: '4px',
    fontSize: 14,
  },
  distance: {
    fontSize: 11,
    color: 'grey.500',
  },
  rightSectionMargin: {
    mt: '3px',
  },
  rightAlign: {
    textAlign: 'right',

  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
